import {
  apiURL
} from '../../config/app';

const getCompany = async authToken => {
  const response = await fetch(`${apiURL}/company`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

const updateCompany = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/company`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

const getUsers = async authToken => {
  const response = await fetch(`${apiURL}/company/users`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

const updateUser = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/company/users/${payload.id}`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

const createUser = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/company/users`, {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()

  return response.json();
};

export default {
  getCompany,
  updateCompany,
  getUsers,
  updateUser,
  createUser
};



// WEBPACK FOOTER //
// ./api/company.js